import React, { Component } from 'react'
import { __ } from '../../services/translate'
import SelectPicker from '../../components/Common/SelectPicker'
import calc2 from '../../assets/img/calc/calc2.png'
import calc4 from '../../assets/img/calc/calc4.png'
import calc1table from '../../assets/img/calc/calctable.png'
import Gallery from '../../components/Common/Gallery'
import { Calculator, CalculatorContainer, Information, Result, SelectRow } from '../../components/Calc'
import { Card, CardImage, CardText, CardTitle } from '../../components/Common/Card'

export default class Calc1 extends Component {

  constructor(props) {
    super(props)

    this.state = {
      number1: 0,
      number2: 0,
    }
  }

  getResult = () => {
    const { number1, number2 } = this.state
    return __(this.props.data.results[number1][number2])
  }

  render() {
    return (
      <CalculatorContainer>
        <Calculator>
          <Card>
            <CardTitle>{__('Metoda přímého přivazování')}</CardTitle>
            <CardImage src={calc2} alt=""/>
            <CardText>
              {__('Nutné jsou nejméně 4 přivazvací prostředky!')}
            </CardText>
          </Card>
          <Card>
            <SelectRow>
              <span>{__('Hmotnost nákladu')}:</span>
              <SelectPicker
                selected={this.state.number1}
                onSelect={(item) => this.setState({ number1: item.id })}
                renderOption={(item) => `${item.value}t`}
                options={this.props.data.weight.map((value, idx) => ({ id: idx, value }))}
              />
            </SelectRow>
            <SelectRow>
              <span>{__('Součinitel tření')}:</span>
              <SelectPicker
                selected={this.state.number2}
                onSelect={(item) => this.setState({ number2: item.id })}
                renderOption={(item) => `${item.value} µ`}
                options={this.props.data.friction.map((value, idx) => ({ id: idx, value }))}
              />
            </SelectRow>
          </Card>
          <Card>
            <CardTitle>{__('Napínací síla každého přivaz. prostředku')} (LC)</CardTitle>
            <CardText>
              {__('Výpočet')}:
              <Result>{this.getResult()}</Result>
            </CardText>
          </Card>
        </Calculator>
        <Information>
          <Card>
            <CardTitle>{__('Součinitel tření')} µ</CardTitle>
            <CardText>{__('Vztah dvou materiálů dle tabulky. Je dobré vyvarovat se znečištení či použíť protiskluzovou podložku.')}</CardText>
            {/*<CardImage src={calc1table} alt=""/>*/}
            <Gallery images={[calc1table]}/>
          </Card>

          <Card>
            <CardTitle>{__('Vertikální úhel')} α</CardTitle>
            <CardText>
              {__('Leží mezi ložnou plochou a upínacím prostředkem. Musí být 20° - 65°!')}
            </CardText>
            <CardImage src={calc2} alt=""/>
          </Card>

          <Card>
            <CardTitle>{__('Vertikální úhel')} β</CardTitle>
            <CardText>
              {__('Leží mezi podélnou osou vozidla a upínacím přostredkem. Musí být 6° - 55°!')}
            </CardText>
            <CardImage src={calc4} alt=""/>
          </Card>
        </Information>
      </CalculatorContainer>
    )
  }
}
